export const CRON_LOG_ID = 'CRON_LOG_ID'
export const PAGE = 'PAGE'
export const PERPAGE = 'PERPAGE'
export const LOG_COUNTS = 'LOG_COUNTS'
export const LAST_PAGE = 'LAST_PAGE'

export const RESPONSE_PAYLOAD = 'RESPONSE_PAYLOAD'
